import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MasterService } from 'src/app/shared/services/master.service';
import { RegistrationService } from 'src/app/shared/services/registration.service';

@Component({
  selector: 'app-registeredcases-modal',
  templateUrl: './registeredcases-modal.component.html',
  styleUrls: ['./registeredcases-modal.component.css']
})
export class RegisteredcasesModalComponent implements OnInit {

  @Input() title: string;
  @Input() isEditDetails: boolean;
  @Input() caseData: any;

  reportDateTime: string = '';
  lstGrid:any[]=[]
  userRoleId: any;
  isDoctor: boolean = false;
  callerNo: string;
  mobileNo: string;
  callId: string;
  defaultMobileNo: boolean;
  callerDetails: any;
  Is1962LiveStock: boolean = false;
  EnableHumanMMU: boolean = false;
  dtOptions: { pagingType: string; pageLength: number; dom: string; processing: boolean; buttons: { extend: string; title: string; exportOptions: { columns: string; }; }[]; };
  dtRender: boolean;

    constructor(private regService: RegistrationService
      , protected toastr: ToastrService
       ,private modalService: NgbModal
       ,public activeModal: NgbActiveModal
      , private formBuilder: FormBuilder
      , private datePipe: DatePipe
      , private masterService: MasterService
      , private router:Router
      , public changeDetection: ChangeDetectorRef) { }

  ngOnInit(): void {
     this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 15,
      dom: 'Bfrtip',
      processing: true,
        buttons: [
          
            {
              extend: 'excelHtml5',
              title: 'Registered Cases List',
              exportOptions: { columns: ':visible:not(:first-child)' }
          },
      ]

    };
    this.getFeaturePermission();
    this.userRoleId = sessionStorage.getItem('logUsrRoleId')
    if(this.userRoleId == 7){
      this.isDoctor=true
    }

    if (sessionStorage.loginUserMobile) {
      let Phone_no = sessionStorage.getItem('loginUserMobile')
      let call_id = sessionStorage.getItem('loginCallId')
      
     if(Phone_no.length>10){
      this.callerNo= Phone_no.slice(-10);
      this.mobileNo = this.callerNo
     }else{
      this.callerNo = Phone_no
     }
      this.callId=call_id
      this.defaultMobileNo=true
      this.callerData();
    }
  }

   getFeaturePermission() {
    var featureList: any = JSON.parse(localStorage.getItem('featuresList'));
    for (let i = 0; i < featureList.length; i++) {
      if (featureList[i].feature_id.feature_name == "1962LiveStock") {
        this.Is1962LiveStock  = featureList[i].patient;
      }
      if (featureList[i].feature_id.feature_name == "EnableHumanMMU") {
        this.EnableHumanMMU  = featureList[i].patient;
      }
    }
  }

   callerData() {
    let APIpath:any
      APIpath=`mvu/farmer/verifyfarmer?mobile=${this.mobileNo}`
    this.regService.get(`${APIpath}`).subscribe({
      next: res => {
        if (res.status == 'OK') {
           this.callerDetails = res.data[0]??[]
        //  this.toastr.success(res.message)
        this.getRegisteredCases()

        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);
      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }

  getRegisteredCases(){
    this.dtRender = false
     this.regService.get(`mvu/case-registration/findbycallerid-new/${this.callId}`).subscribe({
         next: res => {
           if (res.status == 'OK') {
              this.lstGrid = res.data??[]
              this.dtRender = true
            // this.toastr.success(res.message)
   
           } else {
             let errMsg: string = res.message;
             this.toastr.error(errMsg);
             this.dtRender = true
           }
         },
         error: (err: HttpErrorResponse) => {
           this.toastr.error(err.message);
           this.dtRender = true
   
         },
         complete: () => {
           // Any additional logic after patching values
         },
       });
  }

   openPoc(item:any){
      this.router.navigate(['home/mvupocoffline'], { queryParams: { id: item.id , animalDetails:JSON.stringify(item)} });
  }

  close() {
    this.activeModal.dismiss('Cross click');
  }
}
